import { Module } from 'wrapper6';
import $ from 'jquery';

export default class AutofillForm extends Module {

	ready() {

        // Update hidden input field with current page title
        const ELEMENTS = document.querySelectorAll('.autofill-city');
        const MAIN_PAGE = document.querySelector('main.page');

        if (ELEMENTS.length && MAIN_PAGE) {

            let title = MAIN_PAGE.getAttribute('data-title');

            for (let i = 0; i < ELEMENTS.length; i++) {
                ELEMENTS[i].value = title;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_autofill-form.js